export default [
  {
    path: '/jackpot-setting',
    name: 'jackpot-setting',
    component: () => import('@/views/jackpotSetting/JackpotSetting.vue'),
    meta: {
      pageTitle: 'breadcrumb.jackpotSetting',
      resource: 'bet-setting',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.jackpotSetting',
          active: true,
        },
      ],
    },
  },
]
